import React from "react";
import "../NagthaneComponent/NagthaneCss/ AdministrationSection.css";
import member1 from "../Images/Administration.jpg"; 
import member2 from "../Images/Administration2.png";

export default function AdministrationSection() {
  return (
    <section className="admin-section">
      <h2 className="admin-title">ग्रामपंचायत प्रशासन</h2>

      <div className="admin-grid">

        {/* Card 1 */}
        <div className="admin-card">
          <img src={member1} alt="Sarpanch" className="admin-photo" />

          <h3 className="admin-name">सौ. रुपाली सुजित बेंद्रे</h3>
          <p className="admin-position">सरपंच, ग्रामपंचायत नागठाणे</p>
        </div>

        {/* Card 2 */}
        <div className="admin-card">
          <img src={member2} alt="Up-Sarpanch" className="admin-photo" />

          <h3 className="admin-name">श्री. अनिल पांडुरंग सालुखे</h3>
          <p className="admin-position">उपसरपंच, ग्रामपंचायत नागठाणे</p>
        </div>

      </div>
    </section>
  );
}
